import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../styles/Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    closeMenu();

    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <div className="container header-content">
        <h1 className="logo" onClick={scrollToTop} role="button" tabIndex={0}>LeagueTools</h1>
        <button
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? (
            <FaTimes size={28} />
          ) : (
            <FaBars size={28} />
          )}
        </button>
        <nav className={isMenuOpen ? 'open' : ''}>
          <ul>
            <li><a href="#features" onClick={(e) => scrollToSection(e, 'features')}>Features</a></li>
            <li><a href="#screenshots" onClick={(e) => scrollToSection(e, 'screenshots')}>Screenshots</a></li>
            <li><a href="https://leaguetools.dysolix.dev/download" download onClick={closeMenu}>Download</a></li>
            <li><a href="#legal" onClick={(e) => scrollToSection(e, 'legal')}>Legal</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 